import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { api, formatApiErrorDetail, rememberEmail, rememberedEmail } from "../lib/api";

async function fetchOrder(reference, email) {
  if (email) return api.post(`/orders/${reference}/view`, { email });
  return api.get(`/orders/${reference}`);
}

function reportLoadError(e, email, clearEmail) {
  if (email && e.response?.status !== 404) {
    toast.error(formatApiErrorDetail(e.response?.data?.detail));
    clearEmail();
    return;
  }
  toast.error("Registration not found.");
}

export function useConfirmation(reference) {
  const [data, setData] = useState(null);
  const [jerseySize, setJerseySize] = useState("");
  const [email, setEmail] = useState(() => rememberedEmail(reference));
  const [busy, setBusy] = useState(false);

  const load = useCallback(async () => {
    setBusy(true);
    try {
      const res = await fetchOrder(reference, email);
      setData(res.data);
      setJerseySize(res.data.gift?.jersey_size || "");
      if (email) rememberEmail(reference, email);
    } catch (e) { reportLoadError(e, email, () => setEmail("")); }
    finally { setBusy(false); }
  }, [reference, email]);
  useEffect(() => { load(); }, [load]);

  const saveSize = async () => {
    try { await api.post(`/orders/${reference}/gift-size`, { jersey_size: jerseySize, email }); toast.success("Jersey size saved!"); load(); }
    catch (e) { toast.error(formatApiErrorDetail(e.response?.data?.detail)); }
  };

  return { data, jerseySize, setJerseySize, setEmail, busy, saveSize };
}
